// import React, { useEffect, useState } from "react";
// import "./Blogs.css";
// import axios from "axios";

// const Blogs = () => {
//   const [blogs, setBlogs] = useState([]);
//   const [active, setActive] = useState(0);

//   useEffect(() => {
//     fetchBlogs();
//   }, []);

//   // Fetch Blogs
//   const fetchBlogs = async () => {
//     try {
//       const res = await axios.get("http://localhost:5000/api/blogs");
//       setBlogs(res.data);
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   // 🔥 Auto Slide
//   useEffect(() => {
//     if (blogs.length === 0) return;

//     const interval = setInterval(() => {
//       setActive((prev) => (prev + 1) % blogs.length);
//     }, 4000);

//     return () => clearInterval(interval);
//   }, [blogs]);

//   return (
//     <div className="blog-page">

//       {/* ===== VERTICAL CAROUSEL ===== */}
//       <div className="vertical-carousel">
//         {blogs.map((blog, index) => (
//           <div
//             key={blog._id}
//             className={`v-slide ${index === active ? "active" : ""}`}
//             style={{ backgroundImage: `url(${blog.image})` }}
//           >
//             <div className="v-overlay">
//               <h1>{blog.title}</h1>
//               <p>{blog.content.substring(0, 100)}...</p>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* ===== BLOG GRID ===== */}
//       <section className="blog-section">
//         <h2>Latest Blogs</h2>

//         <div className="blog-grid">
//           {blogs.map((blog) => (
//             <div className="blog-card" key={blog._id}>
//               <img src={blog.image} alt="" />

//               <div className="blog-content">
//                 <h3>{blog.title}</h3>

//                 <p className="date">
//                   {new Date(blog.createdAt).toDateString()}
//                 </p>

//                 <p>{blog.content.substring(0, 120)}...</p>

//                 <button>Read More</button>
//               </div>
//             </div>
//           ))}
//         </div>
//       </section>

//     </div>
//   );
// };

// export default Blogs;


import React, { useEffect, useState } from "react";
import "./Blogs.css";
import axios from "axios";
import N1 from "../assets/nursing1.png";
import N2 from "../assets/nursing2.png";
import N3 from "../assets/home.png" ;
import edu1 from "../assets/bsc nursing .mp4";
import edu2 from "../assets/EDU INDIAN NURSING ACADEMY (1).mp4";
import edu3 from "../assets/EDU.vdo.mp4";
import edu4 from "../assets/EDU.vdonew.mp4";
import edu5 from "../assets/edu indian .mp4"
const carouselImages = [
 N1,
N2,
N3
];


const videoSlides = [
  {
    video:
      edu1,
    title: "Learn Nursing Profession",
    subtitle: "Build your future with top universities",
  },

  {
    video:
      edu2,
    title: "Admission Guidance",
    subtitle: "Trusted support for nursing admissions",
  },

   {
    video:
      edu3,
    title: "Admission Guidance",
    subtitle: "Trusted support for nursing admissions",
  },

   {
    video:
      edu4,
    title: "Admission Guidance",
    subtitle: "Trusted support for nursing admissions",
  },

   {
    video:
      edu5,
    title: "Admission Guidance",
    subtitle: "Trusted support for nursing admissions",
  },
];

const Blogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const res = await axios.get("https://edu-nursing-server.onrender.com/api/blogs");
      setBlogs(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  // 🔥 Auto Slide
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % carouselImages.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);



  const [videoCurrent, setVideoCurrent] = useState(0);

const nextVideo = () => {
  setVideoCurrent((prev) => (prev + 1) % videoSlides.length);
};

const prevVideo = () => {
  setVideoCurrent(
    (prev) => (prev - 1 + videoSlides.length) % videoSlides.length
  );
};




const [isPlaying, setIsPlaying] = useState(true);

useEffect(() => {
  const videos = document.querySelectorAll(".video-slide video");

  videos.forEach((video, index) => {
    if (index === videoCurrent && isPlaying) {
      video.play();
    } else {
      video.pause();
    }
  });
}, [videoCurrent, isPlaying]);

  return (
    <div className="blog-page">

      {/* ===== Vertical Carousel ===== */}
      <div className="vertical-carousel">
        {carouselImages.map((img, index) => (
          <div
            key={index}
            className={`v-slide ${index === current ? "active" : ""}`}
            style={{ backgroundImage: `url(${img})` }}
          ></div>
        ))}

        <div className="v-overlay">
          <h1>Our Blog</h1>
          <p>Latest Updates & Insights from Technowin</p>
        </div>
      </div>

{/* ===== FULL VIDEO CAROUSEL ===== */}
{/* ===== FULL VIDEO CAROUSEL ===== */}
<section className="video-carousel">

  <div
    className="video-slider"
    style={{
      transform: `translateX(-${videoCurrent * 100}%)`,
    }}
  >

    {videoSlides.map((slide, index) => (
      <div className="video-slide" key={index}>

       <video
  src={slide.video}
  autoPlay={index === videoCurrent && isPlaying}
  
  loop
  playsInline
  controls={false}
/>


        <div className="video-overlay">
          
          

       
        </div>

      </div>
    ))}

  </div>

  {/* LEFT BUTTON */}
  <button className="carousel-btn left" onClick={prevVideo}>
    ❮
  </button>

  {/* RIGHT BUTTON */}
  <button className="carousel-btn right" onClick={nextVideo}>
    ❯
  </button>

  {/* PLAY / PAUSE BUTTON */}
<button
  className="play-pause-btn"
  onClick={() => setIsPlaying(!isPlaying)}
>
  {isPlaying ? "❚❚" : "▶"}
</button>

</section>





      {/* ===== BLOG GRID ===== */}
      <section className="blog-section">
        <h2>Latest Blogs</h2>

        <div className="blog-grid">
          {blogs.map((blog) => (
            <div className="blog-card" key={blog._id}>
              <img src={blog.image} alt="" />

              <div className="blog-content">
                <h3>{blog.title}</h3>

                <p className="date">
                  {new Date(blog.createdAt).toDateString()}
                </p>

                <p>{blog.content.substring(0, 120)}...</p>

                <button>Read More</button>
              </div>
            </div>
          ))}
        </div>
      </section>

    </div>
  );
};

export default Blogs;